module.exports = __webpack_public_path__ + "img/bay-hotel-5.5242c76d.jpg";